export default function OffsetIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M2.91667 12.25C2.59583 12.25 2.32118 12.1358 2.09271 11.9073C1.86424 11.6788 1.75 11.4042 1.75 11.0833V2.91667C1.75 2.59583 1.86424 2.32118 2.09271 2.09271C2.32118 1.86424 2.59583 1.75 2.91667 1.75H11.0833C11.4042 1.75 11.6788 1.86424 11.9073 2.09271C12.1358 2.32118 12.25 2.59583 12.25 2.91667V11.0833C12.25 11.4042 12.1358 11.6788 11.9073 11.9073C11.6788 12.1358 11.4042 12.25 11.0833 12.25H2.91667ZM2.91667 11.0833H11.0833V2.91667L2.91667 11.0833ZM8.45833 10.5V9.33333H7.29167V8.45833H8.45833V7.29167H9.33333V8.45833H10.5V9.33333H9.33333V10.5H8.45833ZM3.5 4.95833H6.41667V4.08333H3.5V4.95833Z"
        fill="#838383"
      />
    </svg>
  );
}
